/**
 * Los íconos de la navegación y de la barra superior.
 *
 * Dibujados acá y no traídos de una biblioteca, igual que el ojo y el
 * engranaje: son ocho formas simples y no justifican una dependencia que
 * después hay que mantener y auditar. Todos comparten caja, trazo y remates,
 * que es lo que hace que se lean como una familia.
 */
const FORMAS = {
  resumen: 'M4 4h7v7H4zM13 4h7v4h-7zM13 11h7v9h-7zM4 14h7v6H4z',
  procesos: 'M5 5.5a1.8 1.8 0 1 0 0 .01M19 5.5a1.8 1.8 0 1 0 0 .01M12 18.5a1.8 1.8 0 1 0 0 .01M6.8 5.5h10.4M6 7.2l5 9.6M18 7.2l-5 9.6',
  analisis: 'M3.5 17.5 8.5 12l4 4 8-9M3.5 21h17',
  rendimiento: 'M4.6 18.2a9 9 0 1 1 14.8 0M12 14l3.6-4.2',
  releases: 'M3.5 12.2V4.5h7.7l9 9a1.4 1.4 0 0 1 0 2l-5.7 5.7a1.4 1.4 0 0 1-2 0zM7.6 8.1h.01',
  versiones: 'M12 3.5 20.5 8 12 12.5 3.5 8zM3.5 12.5 12 17l8.5-4.5M3.5 16.5 12 21l8.5-4.5',
  auditoria: 'M12 3 19.5 6v6c0 4.6-3.2 7.6-7.5 9-4.3-1.4-7.5-4.4-7.5-9V6zM9 12l2.2 2.2L15.2 10',
  buscar: 'M10.5 17a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM20 20l-4.8-4.8',
  menu: 'M4 7h16M4 12h16M4 17h16',
  cerrar: 'M6 6l12 12M18 6 6 18',
  actividad: 'M3 12h4l2.5-6 5 12 2.5-6H21',
  alerta: 'M12 4 21 19.5H3zM12 10v4.5M12 17.4h.01',
  servicio: 'M4 6h16v5H4zM4 13h16v5H4zM7.5 8.5h.01M7.5 15.5h.01',
  traza: 'M4 6h9M4 12h14M4 18h7',
  contraer: 'M4 5.5h16v13H4zM9.5 5.5v13M16.5 9.5 14 12l2.5 2.5',
  expandir: 'M4 5.5h16v13H4zM9.5 5.5v13M14 9.5l2.5 2.5-2.5 2.5',
  salir: 'M10 4.5H5.5v15H10M14.5 8.5 18 12l-3.5 3.5M18 12H9.5',
} as const;

export type NombreIcono = keyof typeof FORMAS;

export function Icono({ nombre, tamano = 18 }: { nombre: NombreIcono; tamano?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={tamano} height={tamano} aria-hidden="true" focusable="false" className="icono-svg">
      <path
        d={FORMAS[nombre]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
